import React from 'react';
import { Check, Crown, X } from 'lucide-react';
export function Upsell() {
  const rows = [{
    situation: 'Alumno que no sigue el ritmo',
    without: 'Improvisás',
    with: 'Versión adaptada lista en 30 segundos'
  }, {
    situation: 'Informes de diciembre',
    without: 'Lo armás desde cero',
    with: '150 frases listas para copiar y pegar'
  }, {
    situation: 'Día de acto con chicos dispersos',
    without: 'No sabés qué hacer',
    with: '20 juegos sin materiales, para hoy'
  }, {
    situation: 'Reunión difícil con una familia',
    without: 'No sabés cómo decirlo',
    with: 'Guion profesional listo'
  }, {
    situation: 'Efeméride sin decoración',
    without: 'Pinterest a medianoche',
    with: 'Glosas, souvenirs y decoración express'
  }];
  return <section className="py-16 md:py-24 px-4 bg-slate-50 border-y border-slate-200" data-id="element-438">
      <div className="max-w-5xl mx-auto" data-id="element-439">
        <div className="text-center mb-10 md:mb-14" data-id="element-440">
          <p className="text-secondary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-441">
            <Crown className="w-4 h-4" data-id="element-442" /> Upgrade premium
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto text-slate-900" data-id="element-443">
            ¿Qué agrega el{' '}
            <span className="text-secondary" data-id="element-444">Aula Resuelta Pro?</span>
          </h2>
        </div>

        <div className="bg-white border border-secondary/30 rounded-3xl p-6 md:p-10 shadow-[0_10px_40px_rgba(124,58,237,0.08)] mb-8 overflow-x-auto" data-id="element-445">
          <div className="min-w-[600px]" data-id="element-446">
            <div className="grid grid-cols-3 gap-4 mb-4 pb-4 border-b border-slate-200 text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-447">
              <div data-id="element-448">Situación</div>
              <div className="text-red-500 flex items-center gap-1.5" data-id="element-449">
                <X className="w-4 h-4" data-id="element-450" /> Sin el Pro
              </div>
              <div className="text-secondary flex items-center gap-1.5" data-id="element-451">
                <Check className="w-4 h-4" data-id="element-452" /> Con el Pro
              </div>
            </div>

            <div className="space-y-4" data-id="element-453">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 items-center py-3 border-b border-slate-100 last:border-0" data-id="element-454">
                  <div className="text-slate-900 font-bold text-sm md:text-base" data-id="element-455">
                    {row.situation}
                  </div>
                  <div className="text-slate-500 text-sm md:text-base" data-id="element-456">
                    {row.without}
                  </div>
                  <div className="text-secondary font-bold text-sm md:text-base bg-secondary/10 px-3 py-2 rounded-lg inline-block w-fit" data-id="element-457">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-slate-700 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-458">
          Si además de resolver tus clases querés{' '}
          <span className="text-secondary font-bold" data-id="element-459">
            resolver los imprevistos del aula,
          </span>{' '}
          esta es tu opción.
        </p>
      </div>
    </section>;
}